import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType } from 'vue';
import { ProjectShortInfo } from '@/modules/Chat/interfaces/ProjectShortInfo';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import { getProjectsConnectionAndOfferIdString } from '@/modules/Chat/helpers/ChatHelper';


export default /*#__PURE__*/_defineComponent({
  __name: 'TabItem',
  props: {
    projectInfo: {
        type: Object as PropType<ProjectShortInfo>,
        required: true,
    },
    selectedProjectId: {
        type: String as PropType<string | null>,
        default: null,
    },
},
  setup(__props) {

const props = __props;



const bottomRowText = computed(() => {
    return getProjectsConnectionAndOfferIdString(props.projectInfo.offerId, props.projectInfo.connection);
});

function onClick() {
    EventBus.$emit(EventBusEvents.openChatProject, props.projectInfo.projectId);
    EventBus.$emit(EventBusEvents.resetChatInputForm);
}

return { __sfc: true,props, bottomRowText, onClick }
}

})